import React from 'react';
import { Home } from 'react-feather';

import { IRouter } from '@routers/interface';

export const routerDashboard: IRouter = {
  path: '/',
  loader: React.lazy(() => import('./index')),
  exact: true,
  widthFull: true,
  menu: {
    icon: <Home />,
  },
  name: 'dashboard.name', //translate here for breadcrumb and sidebar
};
